import {Inject, Injectable} from "@angular/core";
import {ConnectionHttpService, ApiResourceLocation, SOFTLINE_SERVICE_HTTP} from "@softline/core";
import {
  SOFTLINE_API_LLR_KOMMISSIONIERUNG_PALETTE,
  SOFTLINE_API_LLR_KOMMISSIONIERUNG_PALETTEN_MENGE_UEBERNEHMEN
} from "../kommissionierung.api";
import {Observable} from "rxjs";
import {Palette} from "../types/palette";

@Injectable()
export class PaletteService {
  private loadPaletteLocation(idpalette: string): ApiResourceLocation {
    return {
      path: SOFTLINE_API_LLR_KOMMISSIONIERUNG_PALETTE,
      pathParams: {
        idpalette: idpalette
      }
    }
  }

  private palettenMengeUebernehmenLocation(idpalette: string): ApiResourceLocation {
    return {
      path: SOFTLINE_API_LLR_KOMMISSIONIERUNG_PALETTEN_MENGE_UEBERNEHMEN,
      pathParams: {
        idpalette: idpalette
      }
    }
  }

  constructor(
    @Inject(SOFTLINE_SERVICE_HTTP) private httpService: ConnectionHttpService
  ) {}

  loadPalette(idpalette: string): Observable<Palette> {
    const location = this.loadPaletteLocation(idpalette);

    return this.httpService.get<Palette>(location);
  }

  palettenMengeUebernehmen(idpalette: string, payload: Palette): Observable<Palette> {
    const location = this.palettenMengeUebernehmenLocation(idpalette);

    return this.httpService.create<object, Palette>(location, payload);
  }
}
